const CloudOff = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3768 10.4382C15.522 10.0616 15.6016 9.65239 15.6016 9.22461C15.6016 7.46693 14.2579 6.02308 12.5418 5.86414C12.1907 3.72871 10.3364 2.09961 8.10156 2.09961C7.76664 2.09961 7.44026 2.1362 7.12621 2.2056M4.56715 3.814C4.10644 4.39776 3.78725 5.09839 3.66137 5.86414C1.94519 6.02308 0.601562 7.46693 0.601562 9.22461C0.601562 11.0886 2.1126 12.5996 3.97656 12.5996H12.2266C12.5686 12.5996 12.8988 12.5487 13.2099 12.4541M1.35156 0.599609L14.8516 14.0996"
      stroke="#C01515"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloudOff;
